import { SipNumberResponse } from "../../model/sipNumberResponse";
import { transformDate } from "../../utils/date-helpers";
import { getPhoneNumberE164 } from "../../utils/general-helpers";
import { fetchGetJSON } from "../api-helpers";
import { apiUrls } from "../constants";

type DtoType = SipNumberResponse;

type FetchResponseType = {
  data?: DtoType[];
  error?: string;
};

export type TransformedDataType = DtoType & {
  phoneNumberX: string;
  addedToPoolX: string;
  releaseDateX: string;
  lastUsedBySystemX: string;
};

export type ResponseGuiType = {
  data?: TransformedDataType[];
  error?: string;
};

const moduleState = {
  sipNumberStatusOptionValues: [] as string[],
  adStatusOptionValues: [] as string[],
  typeOptionValues: [] as string[],
};

export async function getSipNumbersData(): Promise<ResponseGuiType> {
  try {
    const url = apiUrls.getSipNumbersData;
    const response: FetchResponseType = await fetchGetJSON(url);
    if (response.error) {
      return { error: response.error };
    } else if (response.data) {
      const sipNumberStatusOptionValues: string[] = [];
      const adStatusOptionValues: string[] = [];
      const typeOptionValues: string[] = [];

      const responseX = response.data.map((item) => {
        sipNumberStatusOptionValues.push(item.sipStatus.name);
        adStatusOptionValues.push(item.adStatus || " ");
        typeOptionValues.push(item.type || " ");

        return {
          ...item,
          phoneNumberX: getPhoneNumberE164(item.phoneNumber),
          addedToPoolX: transformDate(item.addedToPool),
          releaseDateX: transformDate(item.releaseDate),
          lastUsedBySystemX: transformDate(item.lastUsedBySystem),

          //set null/undefined to spaces, to support filtering
          adStatus: item.adStatus || " ",
          type: item.type || " ",
        };
      }); /*.slice(0,10)*/
      //dedup sipNumberStatuses
      const uniqueSipNumberStatuses = Array.from(
        new Set(sipNumberStatusOptionValues)
      );
      moduleState.sipNumberStatusOptionValues =
        sipNumberStatusPresentationOrder.filter((sipStatus) => {
          return uniqueSipNumberStatuses.includes(sipStatus);
        });

      //dedup adStatuses
      const uniqueAdStatuses = Array.from(new Set(adStatusOptionValues));
      moduleState.adStatusOptionValues = uniqueAdStatuses.sort();

      //dedup typeStatuses
      const uniqueTypeStatuses = Array.from(new Set(typeOptionValues));
      moduleState.typeOptionValues = uniqueTypeStatuses.sort();

      return { data: responseX };

      // const largeData = [...responseX, ...responseX, ...responseX, ...responseX].map((row, index) => {
      //   return {
      //     ...row,
      //     id: index
      //   }
      // });
      // return { data: largeData };
    }
    return { error: "invariant violation" };
  } catch (err) {
    console.error("Error getSipNumbersData:%o", err);
    return { error: (err as Error).message };
  }
}

const sipNumberStatusPresentationOrder = [
  "Assigned",
  "Unassigned",
  "Reserved",
  "Retired",
  "Hold",
  "Assigning",
  "Removing",
  "Error",
];
export function getSipNumberStatusOptionValues(): string[] {
  return moduleState.sipNumberStatusOptionValues;
}

export function getAdStatusOptionValues(): string[] {
  return moduleState.adStatusOptionValues;
}

export function getTypeOptionValues(): string[] {
  return moduleState.typeOptionValues;
}
